<!-- Top Header -->
<div class="top-header top-header-style-three">
  <div class="header-shell">
    <div class="row align-items-center g-0">
      <div class="col-lg-6 col-md-6">
        <div class="top-header-news">
          <span class="news-label">News |</span>

          <div class="news-text-wrap">
            <p class="news-text" *ngIf="newsItems.length > 0">
              {{ newsItems[currentNewsIndex] }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-6">
        <ul class="top-header-login-register">
          <li>
            <a
              routerLink="/psd"
              class="nav-link"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              Public Self Disclosure
            </a>
          </li>

          <li>
            <a
              routerLink="/stakeholdersfeedback"
              class="nav-link"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              Stakeholders' Feedback
            </a>
          </li>

          <li>
            <a href="http://stmichaelgroup.in" target="_blank" rel="noopener">
              ERP Login
            </a>
          </li>

      <li class="counselling-code-badge">
  <span class="code-label">Counselling Code</span>
  <span class="code-number">{{ counsellingCode }}</span>
</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<header class="header-area p-relative">
  <!-- Logo Header -->
  <div class="custom-header">
    <div class="header-shell logo-shell">
      <div class="logo-band">
        <div class="logo-wing logo-wing-left">
          <div class="logo-slot">
            <img src="assets/img/15yearst.png" alt="15 Years" />
          </div>
          <div class="logo-slot">
            <img src="assets/img/iict.png" alt="IICT" />
          </div>
          <div class="logo-slot">
            <img src="assets/img/flogo.png" alt="FMCET" />
          </div>
        </div>

<div class="logo-center">
  <div class="brand-text">
    <h1>FATIMA MICHAEL COLLEGE OF ENGG. & TECH.</h1>
    <p class="autonomous">(An Autonomous Institution)</p>
    <p class="naac">Accredited by NAAC with A+ Grade</p>
    <p class="affiliation">
      (Approved by AICTE, New Delhi, Affiliated to Anna University, Chennai)
    </p>
  </div>
</div>
        <div class="logo-wing logo-wing-right">
          <div class="logo-slot">
            <img src="assets/img/logo.png" alt="Logo" />
          </div>
          <div class="logo-slot">
            <img src="assets/img/qrot.png" alt="QRO" />
          </div>
          <div class="logo-slot">
            <img src="assets/img/aplus.png" alt="A Plus" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Navbar -->
  <div
    class="navbar-area navbar-style-three"
    [ngClass]="{ sticky: isSticky }"
    [class.dark-navbar-area]="themeService.isDark()"
  >
    <div class="header-shell nav-shell">
      <nav
        class="navbar navbar-expand-lg navbar-light bg-light"
        [class.active]="classApplied"
      >
        <a
          class="navbar-brand"
          routerLink="/"
          [class.d-none]="themeService.isDark()"
        ></a>

        <a
          class="navbar-brand d-none"
          routerLink="/"
          [class.d-block]="themeService.isDark()"
        ></a>

        <button
          class="navbar-toggler"
          type="button"
          (click)="toggleClass()"
          [attr.aria-expanded]="classApplied"
          aria-label="Toggle navigation"
        >
          <span class="burger-menu">
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
          </span>
        </button>

        <div
          class="collapse navbar-collapse"
          id="navbarSupportedContent"
          [class.show]="classApplied"
        >
          <ul class="navbar-nav full-width-menu">
            <li class="nav-item">
              <a
                routerLink="/"
                class="nav-link"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="onMenuLinkClick()"
              >
                Home
              </a>
            </li>

            <li class="nav-item">
              <a
                routerLink="/aboutus"
                class="nav-link"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="onMenuLinkClick()"
              >
                About Us
              </a>
            </li>

            <li
              class="nav-item has-dropdown"
              [class.is-open]="isDropdownOpen('admission')"
            >
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-parent"
                (click)="toggleMobileDropdown('admission', $event)"
                [attr.aria-expanded]="isDropdownOpen('admission')"
              >
                Admission
                <i class="bx bx-chevron-down"></i>
              </a>

              <ul class="dropdown-menu">
                <li class="nav-item">
                  <a
                    routerLink="/admission"
                    class="nav-link"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    (click)="onMenuLinkClick()"
                  >
                    Admission 
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    routerLink="/programme"
                    class="nav-link"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    (click)="onMenuLinkClick()"
                  >
                    Programme Offered
                  </a>
                </li>
              </ul>
            </li>

            <li
              class="nav-item has-dropdown"
              [class.is-open]="isDropdownOpen('academics')"
            >
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-parent"
                (click)="toggleMobileDropdown('academics', $event)"
                [attr.aria-expanded]="isDropdownOpen('academics')"
              >
                Academics
                <i class="bx bx-chevron-down"></i>
              </a>

              <ul class="dropdown-menu">
          

                <li
                  class="nav-item has-submenu"
                  [class.is-open]="isDropdownOpen('departments')"
                >
                  <a
                    href="javascript:void(0)"
                    class="nav-link nav-link-parent"
                    (click)="toggleMobileDropdown('departments', $event)"
                    [attr.aria-expanded]="isDropdownOpen('departments')"
                  >
                    Departments
                    <i class="bx bx-chevron-right"></i>
                  </a>

                  <ul class="dropdown-menu submenu-right">
                    <li class="nav-item">
                      <a
                        routerLink="/civil"
                        class="nav-link"
                        routerLinkActive="active"
                        (click)="onMenuLinkClick()"
                      >
                        Civil Engineering
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        routerLink="/cse"
                        class="nav-link"
                        routerLinkActive="active"
                        (click)="onMenuLinkClick()"
                      >
                        Computer Science &amp; Engineering
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        routerLink="/ai"
                        class="nav-link"
                        routerLinkActive="active"
                        (click)="onMenuLinkClick()"
                      >
                        CSE (AI &amp; ML)
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        routerLink="/cs"
                        class="nav-link"
                        routerLinkActive="active"
                        (click)="onMenuLinkClick()"
                      >
                        CSE (Cyber Security)
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        routerLink="/ece"
                        class="nav-link"
                        routerLinkActive="active"
                        (click)="onMenuLinkClick()"
                      >
                        Electronics &amp; Communication Engineering
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        routerLink="/eee"
                        class="nav-link"
                        routerLinkActive="active"
                        (click)="onMenuLinkClick()"
                      >
                        Electrical &amp; Electronics Engineering
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        routerLink="/mech"
                        class="nav-link"
                        routerLinkActive="active"
                        (click)="onMenuLinkClick()"
                      >
                        Mechanical Engineering
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        routerLink="/sh"
                        class="nav-link"
                        routerLinkActive="active"
                        (click)="onMenuLinkClick()"
                      >
                        Science &amp; Humanities Department
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        routerLink="/mba"
                        class="nav-link"
                        routerLinkActive="active"
                        (click)="onMenuLinkClick()"
                      >
                        Master of Business Administration
                      </a>
                    </li>
                  </ul>
                </li>

                <li
                  class="nav-item has-submenu"
                  [class.is-open]="isDropdownOpen('faculty')"
                >
                  <a
                    href="javascript:void(0)"
                    class="nav-link nav-link-parent"
                    (click)="toggleMobileDropdown('faculty', $event)"
                    [attr.aria-expanded]="isDropdownOpen('faculty')"
                  >
                    Faculty
                    <i class="bx bx-chevron-right"></i>
                  </a>

                  <ul class="dropdown-menu submenu-right">
                    <li class="nav-item">
                      <a
                        routerLink="/teachingfaculty"
                        class="nav-link"
                        routerLinkActive="active"
                        (click)="onMenuLinkClick()"
                      >
                        Teaching
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        routerLink="/nonteachingfaculty"
                        class="nav-link"
                        routerLinkActive="active"
                        (click)="onMenuLinkClick()"
                      >
                        Non-Teaching
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <li class="nav-item">
              <a
                routerLink="/placement"
                class="nav-link"
                routerLinkActive="active"
                (click)="onMenuLinkClick()"
              >
                Placement &amp; Training
              </a>
            </li>

            <li
              class="nav-item has-dropdown"
              [class.is-open]="isDropdownOpen('research')"
            >
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-parent"
                (click)="toggleMobileDropdown('research', $event)"
                [attr.aria-expanded]="isDropdownOpen('research')"
              >
                Research
                <i class="bx bx-chevron-down"></i>
              </a>

              <ul class="dropdown-menu">
                     <li class="nav-item">
                  <a
                    routerLink="/rnd"
                    class="nav-link"
                    routerLinkActive="active"
                    (click)="onMenuLinkClick()"
                  >
                    R & D
                  </a>
                </li>
                     <li class="nav-item">
                  <a
                    routerLink="/edc"
                    class="nav-link"
                    routerLinkActive="active"
                    (click)="onMenuLinkClick()"
                  >
                    EDC
                  </a>
                </li>
                
                <li class="nav-item">
                  <a
                    routerLink="/startup"
                    class="nav-link"
                    routerLinkActive="active"
                    (click)="onMenuLinkClick()"
                  >
                    Startup
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    routerLink="/incubation"
                    class="nav-link"
                    routerLinkActive="active"
                    (click)="onMenuLinkClick()"
                  >
                    Incubation Center
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    routerLink="/IIC"
                    class="nav-link"
                    routerLinkActive="active"
                    (click)="onMenuLinkClick()"
                  >
                    IIC
                  </a>
                </li>
     
              </ul>
            </li>
  
            <li
              class="nav-item has-dropdown"
              [class.is-open]="isDropdownOpen('committees')"
            >
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-parent"
                (click)="toggleMobileDropdown('committees', $event)"
                [attr.aria-expanded]="isDropdownOpen('committees')"
              >
                Committees
                <i class="bx bx-chevron-down"></i>
              </a>

              <ul class="dropdown-menu">
                <li class="nav-item">
                  <a
                    routerLink="/antiragging"
                    class="nav-link"
                    routerLinkActive="active"
                    (click)="onMenuLinkClick()"
                  >
                    Antiragging
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    routerLink="/grc"
                    class="nav-link"
                    routerLinkActive="active"
                    (click)="onMenuLinkClick()"
                  >
                    Grievance Redressal Committee
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    routerLink="/icc"
                    class="nav-link"
                    routerLinkActive="active"
                    (click)="onMenuLinkClick()"
                  >
                    Internal Complaint Committee
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    routerLink="/scst"
                    class="nav-link"
                    routerLinkActive="active"
                    (click)="onMenuLinkClick()"
                  >
                    SC / ST Committee
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    routerLink="/cell"
                    class="nav-link"
                    routerLinkActive="active"
                    (click)="onMenuLinkClick()"
                  >
                    Cell
                  </a>
                </li>
              </ul>
            </li>

            <li class="nav-item">
              <a
                routerLink="/alumni"
                class="nav-link"
                routerLinkActive="active"
                (click)="onMenuLinkClick()"
              >
                Alumni
              </a>
            </li>

            <li class="nav-item">
              <a
                routerLink="/library"
                class="nav-link"
                routerLinkActive="active"
                (click)="onMenuLinkClick()"
              >
                Library
              </a>
            </li>
                   <li class="nav-item">
              <a
                routerLink="/sports"
                class="nav-link"
                routerLinkActive="active"
                (click)="onMenuLinkClick()"
              >
                Sports
              </a>
            </li>

            <li
              class="nav-item has-dropdown"
              [class.is-open]="isDropdownOpen('accreditation')"
            >
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-parent"
                (click)="toggleMobileDropdown('accreditation', $event)"
                [attr.aria-expanded]="isDropdownOpen('accreditation')"
              >
                Accreditation
                <i class="bx bx-chevron-down"></i>
              </a>

              <ul class="dropdown-menu">
                <li class="nav-item">
                  <a
                    routerLink="/NIRF"
                    class="nav-link"
                    routerLinkActive="active"
                    (click)="onMenuLinkClick()"
                  >
                    NIRF
                  </a>
                </li>

                <li
                  class="nav-item has-submenu"
                  [class.is-open]="isDropdownOpen('naacGroup')"
                >
                  <a
                    href="javascript:void(0)"
                    class="nav-link nav-link-parent"
                    (click)="toggleMobileDropdown('naacGroup', $event)"
                    [attr.aria-expanded]="isDropdownOpen('naacGroup')"
                  >
                    NAAC
                    <i class="bx bx-chevron-right"></i>
                  </a>

                  <ul class="dropdown-menu submenu-right">
                    <li class="nav-item">
                      <a
                        routerLink="/IQAC"
                        class="nav-link"
                        routerLinkActive="active"
                        (click)="onMenuLinkClick()"
                      >
                        IQAC
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        routerLink="/naac-criterion"
                        class="nav-link"
                        routerLinkActive="active"
                        (click)="onMenuLinkClick()"
                      >
                        NAAC
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        routerLink="/RTI"
                        class="nav-link"
                        routerLinkActive="active"
                        (click)="onMenuLinkClick()"
                      >
                        RTI
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <li
              class="nav-item has-dropdown"
              [class.is-open]="isDropdownOpen('mandatory')"
            >
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-parent"
                (click)="toggleMobileDropdown('mandatory', $event)"
                [attr.aria-expanded]="isDropdownOpen('mandatory')"
              >
                Mandatory
                <i class="bx bx-chevron-down"></i>
              </a>

              <ul class="dropdown-menu">
                <li class="nav-item">
                  <a
                    href="assets/img/pdf/AICTE.pdf"
                    target="_blank"
                    class="nav-link"
                    (click)="onMenuLinkClick()"
                  >
                    AICTE Approvals 2009-2023
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="assets/img/pdf/AICTE2025.pdf"
                    target="_blank"
                    class="nav-link"
                    (click)="onMenuLinkClick()"
                  >
                    AICTE Approval 2024-2025
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="assets/img/pdf/AICTE2026.pdf"
                    target="_blank"
                    class="nav-link"
                    (click)="onMenuLinkClick()"
                  >
                    AICTE Approval 2025-2026
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="assets/pdfs/md.pdf"
                    target="_blank"
                    class="nav-link"
                    (click)="onMenuLinkClick()"
                  >
                    Mandatory Disclosure
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="https://www.aicte-india.org/feedback/index.php"
                    target="_blank"
                    class="nav-link"
                    (click)="onMenuLinkClick()"
                  >
                    AICTE Feedback
                  </a>
                </li>
              </ul>
            </li>

            <li class="nav-item">
              <a
                routerLink="/gallery"
                class="nav-link"
                routerLinkActive="active"
                (click)="onMenuLinkClick()"
              >
                Gallery
              </a>
            </li>

            <li class="nav-item">
              <a
                routerLink="/contact"
                class="nav-link"
                routerLinkActive="active"
                (click)="onMenuLinkClick()"
              >
                Contact
              </a>
            </li>
          </ul>
        </div>

        <div class="others-option">
          <div
            class="dropdown language-switcher d-inline-block"
            [class.active]="classApplied2"
          ></div>
        </div>
      </nav>
    </div>
  </div>
</header>

<!-- Search Overlay -->
<div
  class="search-overlay"
  [class.active]="classApplied3"
  [class.dark-search-overlay]="themeService.isDark()"
>
  <div class="d-table">
    <div class="d-table-cell">
      <div class="search-overlay-layer"></div>
      <div class="search-overlay-layer"></div>
      <div class="search-overlay-layer"></div>

      <div class="search-overlay-close" (click)="toggleClass3()">
        <span class="search-overlay-close-line"></span>
        <span class="search-overlay-close-line"></span>
      </div>

      <div class="search-overlay-form">
        <form>
          <input type="text" class="input-search" placeholder="Search here..." />
          <button type="submit"><i class="bx bx-search-alt"></i></button>
        </form>
      </div>
    </div>
  </div>
</div>